// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"3ae51f94","787":"1d1b6fce","858":"6c428e03"}[chunkId] + ".chunk.js";
};